import { jsx as e, jsxs as h } from "react/jsx-runtime";
import { useRef as m, useLayoutEffect as u } from "react";
import { twMerge as n } from "tailwind-merge";
import { ArrowIonicRightIcon as d } from "../../icons/arrow-ionic-right-icon.mjs";
import { Loader as w } from "../loader/index.mjs";
import { BreadcrumbItem as p } from "./breadcrumbs-item.mjs";
const y = ({
  data: s,
  isFetching: a,
  classnameBreadcrumbsItem: c,
  CustomBreadcrumbLinkItem: f
}) => {
  const t = m(null), o = m(null);
  return u(() => {
    t.current && o.current && t.current.scrollTo(o.current.offsetLeft, 0);
  }, [a]), /* @__PURE__ */ e(
    "ul",
    {
      ref: t,
      className: `
        md:overflow:hidden hide-scrollbar
        flex min-h-[42px] w-full flex-nowrap items-center gap-3 gap-y-0
        overflow-scroll whitespace-nowrap
        md:flex-wrap md:truncate 
        lg:flex-nowrap
      `,
      children: s.map((r, i) => {
        const l = i === s.length - 1;
        return /* @__PURE__ */ h(
          "li",
          {
            className: n(
              "flex flex-nowrap items-center gap-3 md:truncate",
              r.listItemClassName
            ),
            ref: l ? o : void 0,
            children: [
              i !== 0 && /* @__PURE__ */ e(
                d,
                {
                  height: "14",
                  width: "10",
                  fill: "rgb(var(--text-tertiary))",
                  className: "shrink-0"
                }
              ),
              !r.isStatic && a ? /* @__PURE__ */ e(w, { small: !0, type: "dark" }) : r.href ? /* @__PURE__ */ e(
                p,
                {
                  isLast: l,
                  className: n(c),
                  isLink: !0,
                  onClick: r.onClick,
                  children: f ? /* @__PURE__ */ e(f, { href: r.href, children: r.caption }) : /* @__PURE__ */ e("a", { href: r.href, rel: "noreferrer", className: "outline-hidden", children: r.caption })
                }
              ) : /* @__PURE__ */ e(
                p,
                {
                  onClick: r.onClick,
                  className: n(c),
                  isLast: l,
                  children: r.caption
                }
              )
            ]
          },
          i
        );
      })
    }
  );
};
export {
  y as Breadcrumbs
};
